// Hit-testing on the 2D view (spec §6 "Select"). PURE — works on the plain `view` the worker
// sends (mm, y UP). A small element is hard to hit with a finger, so every element's hit box is
// its ink bounding box grown until it is at least MIN_HIT_PX wide and high on screen.
export const MIN_HIT_PX = 44;

export function boundsOf(polygons) {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const p of polygons) for (const [x, y] of p) {
    if (x < minX) minX = x; if (x > maxX) maxX = x;
    if (y < minY) minY = y; if (y > maxY) maxY = y;
  }
  return { minX, minY, maxX, maxY };
}

// mmPerPx: how many mm one CSS pixel covers in the view right now.
export function hitBox(polygons, mmPerPx, minPx = MIN_HIT_PX) {
  const b = boundsOf(polygons), min = minPx * mmPerPx;
  const padX = Math.max(0, (min - (b.maxX - b.minX)) / 2), padY = Math.max(0, (min - (b.maxY - b.minY)) / 2);
  return { minX: b.minX - padX, minY: b.minY - padY, maxX: b.maxX + padX, maxY: b.maxY + padY };
}

// Ids of the elements whose hit box contains the model point — TOPMOST FIRST (the view draws
// elements in document order, so the last one is on top).
export function hitsAt(view, [x, y], mmPerPx, minPx = MIN_HIT_PX) {
  const ids = [];
  for (const e of view.elements) {
    const h = hitBox(e.polygons, mmPerPx, minPx);
    if (x >= h.minX && x <= h.maxX && y >= h.minY && y <= h.maxY) ids.push(e.id);
  }
  return ids.reverse();
}

// What a tap selects: nothing hit → null (deselect); the selected element hit again → the NEXT
// one under the finger (repeated taps cycle through overlapping elements); otherwise the topmost.
export function tapSelection(hits, selected) {
  if (hits.length === 0) return null;
  const at = hits.indexOf(selected);
  return at < 0 ? hits[0] : hits[(at + 1) % hits.length];
}
